import { formatTimeAgo } from "./dateUtils";

/**
 * Transforms raw `/api/requests/:id/audit-logs` rows into the
 * `{id, action, time, icon}` shape the Activity tab renders. Shared by the
 * Normal, NetSuite and Business Central request views so the Activity tab
 * reads identically everywhere.
 */
export function formatAuditLogsForActivity(rawLogs) {
  return rawLogs
    .filter((log) => {
      const changes = log.changes || [];
      // Skip if no changes recorded
      if (changes.length === 0) return false;
      // Skip INSERT logs from system (extraction) - they don't add value
      if (log.action === "INSERT" && !log.created_by_name) return false;
      // For UPDATE: skip if all changes have both old and new as null/empty
      if (log.action === "UPDATE") {
        const hasMeaningfulChange = changes.some((c) => {
          const oldVal = c.old_value;
          const newVal = c.new_value;
          return (
            (oldVal !== null && oldVal !== undefined && oldVal !== "") ||
            (newVal !== null && newVal !== undefined && newVal !== "")
          );
        });
        if (!hasMeaningfulChange) return false;
      }
      return true;
    })
    .map((log) => {
      const changes = log.changes || [];
      const meaningfulChanges = changes.filter((c) => {
        const oldVal = c.old_value;
        const newVal = c.new_value;
        return (
          (oldVal !== null && oldVal !== undefined && oldVal !== "") ||
          (newVal !== null && newVal !== undefined && newVal !== "")
        );
      });
      const firstChange = meaningfulChanges[0];
      let action = "";
      let icon = "user";

      const formatValue = (val) => {
        if (val === null || val === undefined || val === "") return "(empty)";
        return String(val);
      };

      if (log.action === "INSERT") {
        action = `${log.created_by_name || "System"} added ${firstChange?.display_label || "field"}`;
        if (firstChange?.new_value != null && firstChange.new_value !== "") {
          action += `: "${formatValue(firstChange.new_value)}"`;
        }
        icon = log.created_by_name ? "user" : "system";
      } else if (log.action === "UPDATE") {
        if (meaningfulChanges.length === 1 && firstChange) {
          const fieldLabel = firstChange.display_label || "field";
          action = `${log.created_by_name || "User"} edited ${fieldLabel}`;
          action += `: "${formatValue(firstChange.old_value)}" → "${formatValue(firstChange.new_value)}"`;
        } else if (meaningfulChanges.length > 1) {
          const fieldLabels = meaningfulChanges
            .map((c) => c.display_label || c.field)
            .filter(Boolean);
          action = `${log.created_by_name || "User"} edited ${fieldLabels.join(", ")}`;
        } else {
          action = `${log.created_by_name || "User"} edited ${firstChange?.display_label || "field"}`;
        }
        icon = "user";
      } else if (log.action === "DELETE") {
        action = `${log.created_by_name || "User"} removed ${firstChange?.display_label || "field"}`;
        icon = "user";
      }

      return {
        id: log.id,
        action,
        time: formatTimeAgo(log.created_at),
        icon,
        details: log,
      };
    });
}
